/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  Context,
  Procedure,
  ContextOptions,
  ContextFunction,
  ProcedureOptions,
} from './core';

// export all types
export {
  ContextFunction,
  ContextOptions,
  ContextValue,
  OnAfterHook,
  OnBeforeHook,
  type Context,
  type Procedure,
} from './core';

/**
 * create garda procedure
 */
export function createProcedure<
  O,
  I extends any[],
  T extends Record<string, any>
>(
  context: (() => T) | Context<T>,
  fn: ContextFunction<O, I, T>,
  options: Partial<ProcedureOptions<I, T>> = {}
) {
  const setupProcedure = (procedure: Procedure<O, I, T>) => {
    if (typeof options.onBeforeCalled === 'function') {
      procedure.onBeforeCalled(options.onBeforeCalled);
    }

    if (typeof options.onAfterCalled === 'function') {
      procedure.onAfterCalled(options.onAfterCalled);
    }

    return procedure;
  };

  if (context instanceof Context) {
    const procedure = new Procedure(context, fn);
    return setupProcedure(procedure);
  } else {
    const ctx = new Context(context);
    const procedure = new Procedure(ctx, fn);
    return setupProcedure(procedure);
  }
}

/** Create garda context */
export function createContext<T extends Record<string, any>>(
  context: () => T,
  options: Partial<ContextOptions> = {}
) {
  return new Context(context, options);
}
